import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import MqttClient from './utils/mqttservice';
import {  withTranslation } from "react-i18next";
// import { renderRoutes } from 'react-router-config';
import './App.scss';
import PropTypes from "prop-types";

const loading = () => <div className="animated fadeIn pt-3 text-center">Loading...</div>;
const mqttClient = new MqttClient();


// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const ForgotPassword = React.lazy(() => import('./views/Pages/Login/ForgotPassword'));
const Register = React.lazy(() => import('./views/Pages/Register'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const Page500 = React.lazy(() => import('./views/Pages/Page500'));

class App extends Component {
  componentDidMount(){
    this.props.i18n.changeLanguage(localStorage.getItem("user_preffered_language"));
    mqttClient.connect();
  }

  render(
  ) {
    return (
      <I18nextProvider i18n={i18n}>
      <BrowserRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/forgotpassword" name="Password Page" render={props => <ForgotPassword {...props}/>} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
              <Route path="/" name="Home" render={props => <DefaultLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </BrowserRouter>
      </I18nextProvider>
    );
  }
}
App.propTypes = {
  classes: PropTypes.object.isRequired
};
export default (withTranslation("translations")(App));
